module.exports = __webpack_public_path__ + "static/media/pasamosagosto5.71bf1f64.webp";